import { render, staticRenderFns } from "./suggest.vue?vue&type=template&id=26f791f8&scoped=true&"
import script from "./suggest.vue?vue&type=script&lang=js&"
export * from "./suggest.vue?vue&type=script&lang=js&"
import style1 from "./suggest.vue?vue&type=style&index=1&id=26f791f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f791f8",
  null
  
)

export default component.exports